import { registerTheme } from '../../theme';
import { DEFAULT_COLUMN_THEME } from '../column/theme';

registerTheme('groupedColumn', DEFAULT_COLUMN_THEME);
